import React from 'react';

interface IconProps {
    fill?: string;
    width?: number;
    height?: number;
}

export const CheckIcon = ({ fill = '#252733', width = 9, height = 9 }: IconProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 9 9"
        fill="none"
    >
        <g clipPath="url(#clip0_2073_6)">
            <path
                d="M7.875 8.9625L6.50137 8.02087L5.50238 8.70525L4.50262 8.0205L3.50287 8.7045L2.50125 8.01975L1.125 8.9625V1.125C1.125 0.826631 1.24353 0.540483 1.4545 0.329505C1.66548 0.118526 1.95163 0 2.25 0L6.75 0C7.04837 0 7.33452 0.118526 7.5455 0.329505C7.75647 0.540483 7.875 0.826631 7.875 1.125V8.9625ZM2.50125 7.11075L3.5025 7.7955L4.50262 7.11075L5.50238 7.7955L6.50175 7.11038L7.125 7.5375V1.125C7.125 1.02554 7.08549 0.930161 7.01517 0.859835C6.94484 0.789509 6.84946 0.75 6.75 0.75H2.25C2.15054 0.75 2.05516 0.789509 1.98484 0.859835C1.91451 0.930161 1.875 1.02554 1.875 1.125V7.5375L2.50125 7.11075Z"
                fill={fill}
            />
            <path d="M2.625 3H6.375V3.75H2.625V3ZM2.625 4.5H5.625V5.25H2.625V4.5Z" fill={fill} />
        </g>
        <defs>
            <clipPath id="clip0_2073_6">
                <rect width={width} height={height} fill="white" />
            </clipPath>
        </defs>
    </svg>
);
